import { render, staticRenderFns } from "./EditAssetFormDialogComponent.vue?vue&type=template&id=3b4223f2&"
import script from "./EditAssetFormDialogComponent.vue?vue&type=script&lang=js&"
export * from "./EditAssetFormDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports